export default {
    title: "Verificación de dirección",
    header: "@:views.address.verified.title",
    message: "Gracias por verificar tu dirección. Ahora puede elegir esto como una dirección de envío cuando realiza un pedido.",
}